<script setup lang="ts">
import { useField } from 'vee-validate';

const props = withDefaults(
  defineProps<{
    color: string;
    defaultColor?: string;
    label: string;
    disabled?: boolean;
  }>(),
  { defaultColor: '#ffffff', disabled: false },
);

const { value: colorValue } = useField<string>(props.color);
</script>
<template>
  <div class="color-picker">
    <q-input filled v-model="colorValue" :label="props.label" :disable="props.disabled">
      <template v-slot:append>
        <div class="color-preview" :style="{ backgroundColor: colorValue || props.defaultColor }"></div>
        <q-icon name="colorize" class="cursor-pointer" :class="{ disabled: props.disabled }">
          <q-popup-proxy cover transition-show="scale" transition-hide="scale">
            <q-color v-model="colorValue" :default-value="props.defaultColor" no-footer :disable="props.disabled" />
          </q-popup-proxy>
        </q-icon>
      </template>
    </q-input>
  </div>
</template>

<style scoped>
.color-preview {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  border: 2px solid rgba(0, 0, 0, 0.1);
  margin-right: 8px;
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
}
</style>
